/* Moonreed Refined. Progressive enhancements; Shopify and Zepto own product forms. */
(() => {
  'use strict';
  if (window.MoonreedRefined) return;
  const dayMs = 86400000;
  const dateKey = (d) => d.toISOString().slice(0, 10);
  // Civil dates only: UTC here is a date container, never the customer's timezone.
  function londonParts(now) {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).map(({type, value}) => [type, value]));
    return {day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), minutes: +p.hour * 60 + +p.minute};
  }
  function bankHolidays(year) {
    const dates = new Set();
    const add = (d) => dates.add(dateKey(d));
    const date = (m, d) => new Date(Date.UTC(year, m - 1, d));
    const nextMonday = (d) => { while (d.getUTCDay() !== 1) d = new Date(+d + dayMs); return d; };
    const lastMonday = (m) => { let d = new Date(Date.UTC(year, m, 0)); while(d.getUTCDay() !== 1) d = new Date(+d - dayMs); return d; };
    const ny = date(1, 1); add([0, 6].includes(ny.getUTCDay()) ? nextMonday(ny) : ny);
    // Gregorian Easter, then Good Friday and Easter Monday.
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3);
    const h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    const month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1,easter=date(month,day);
    add(new Date(+easter-2*dayMs));add(new Date(+easter+dayMs));
    add(nextMonday(date(5,1)));add(lastMonday(5));add(lastMonday(8));
    // Christmas/Boxing Day use two distinct substitute working days.
    for (const n of [25,26]) { const d=date(12,n); if (![0,6].includes(d.getUTCDay())) add(d); }
    for (const n of [25,26]) { let d=date(12,n); if ([0,6].includes(d.getUTCDay())) { do {d=new Date(+d+dayMs);} while([0,6].includes(d.getUTCDay())||dates.has(dateKey(d)));add(d); } }
    return dates;
  }
  function dispatchStatus(now, config) {
    const local = londonParts(now);
    const match = /^(\d{1,2}):(\d{2})$/.exec(config.cutoff || '');
    const cutoff = match && +match[1] < 24 && +match[2] < 60 ? +match[1] * 60 + +match[2] : 900;
    const closed = new Set([...(config.holidays || []), ...bankHolidays(local.day.getUTCFullYear()), ...bankHolidays(local.day.getUTCFullYear()+1)]);
    for (let offset=0;offset<35;offset++) {
      const candidate = new Date(+local.day + offset*dayMs);
      if (!config.days[candidate.getUTCDay()] || closed.has(dateKey(candidate))) continue;
      if (offset===0 && local.minutes>=cutoff) continue;
      return {date: dateKey(candidate),today:offset===0,minutes:offset===0?cutoff-local.minutes:null};
    }
    return null;
  }
  function updateShipping() {
    const el = document.getElementById('moonreed-shipping-config');
    if (!el) return;
    const d = el.dataset;
    let days;try { days=JSON.parse(d.dispatch); } catch (_) { return; }
    const status = dispatchStatus(new Date(),{cutoff:d.cutoff,days,holidays:(d.holidays||'').split(/[\s,]+/).filter(Boolean)});
    for (const node of document.querySelectorAll('.moonreed-countdown')) {
      let message = d.fallback;
      if (node.dataset.mode === 'preorder') message = d.preorder;
      else if (node.dataset.mode === 'unavailable') message = d.unavailable;
      else if (d.country === 'GB' && status) {
        if (status.today) {
          const h=Math.floor(status.minutes/60),m=status.minutes%60;
          message=`${d.orderIn} ${h ? h+'h ' : ''}${m}m ${d.dispatchToday}`;
        } else {
          const date = new Date(status.date+'T12:00:00Z');
          message=`${d.nextDispatch} ${new Intl.DateTimeFormat(document.documentElement.lang||'en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'Europe/London'}).format(date)}`;
        }
      }
      if(node.textContent!==message) node.textContent=message;
    }
  }
  // A committed model selection follows the same route as the finder button.
  document.addEventListener('change', (event) => {
    const select=event.target;
    if(!select.matches?.('[data-mr-finder] select') || !select.value || !select.checkValidity())return;
    select.form?.requestSubmit();
  });
  // Keep a standard form submission for keyboard, button and no-JS use.
  document.addEventListener('submit', (event) => {
    const form=event.target.closest('[data-mr-finder]');if(!form)return;
    const select=form.querySelector('select');if(!select.reportValidity()){event.preventDefault();return;}
    const value=select.selectedOptions[0]?.dataset.url;
    if (!value) return; // normal search form is a useful no-JS/data fallback.
    const destination=new URL(value,location.origin);
    if(destination.origin!==location.origin)return;
    event.preventDefault();location.assign(destination.href);
  });
  document.addEventListener('click',(event)=>{
    const link=event.target.closest('[data-mr-options-link]');if(!link)return;
    const panel=document.getElementById(link.hash.slice(1));if(!panel)return;
    event.preventDefault();panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    const control=panel.querySelector('variant-picker input:not([disabled]), variant-picker select, button[onclick*="cstmfy_personalize_text"], button[type="submit"]');
    if(control)control.focus({preventScroll:true});
  });
  let scheduled=false;
  const queueShipping=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;updateShipping();});};
  document.addEventListener('shopify:section:load',queueShipping);
  document.addEventListener('variant:change',queueShipping);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)queueShipping();});
  // Product rerenders are inserted asynchronously by the theme. Only observe relevant additions.
  new MutationObserver((records)=>{
    if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches('.moonreed-countdown,#moonreed-shipping-config')||n.querySelector('.moonreed-countdown,#moonreed-shipping-config')))))queueShipping();
  }).observe(document.body,{childList:true,subtree:true});
  window.MoonreedRefined={dispatchStatus,bankHolidays};
  updateShipping();setInterval(()=>{if(!document.hidden)updateShipping();},60000);
})();
